import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CustomMessageRegionEntity } from '../../domain/entities/CustomMessageRegionEntity'
import { RegionMiniModel } from '@/features/region/data/models/RegionMiniModel'

export class CustomMessageRegionModel extends CustomMessageRegionEntity {
  constructor(dataDto: CustomMessageRegionEntity) {
    super()
    mapEntityProperties<CustomMessageRegionModel>(this, dataDto, {
      exclude: ['region'],
      map: {
        region: dataDto.region ? new RegionMiniModel(dataDto.region) : undefined,
      }
    })
  }
}
